import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.buttonTarget.addEventListener("click", () => this.togglePeekPassword())
  }

  togglePeekPassword() {
    const passwordinput = this.element.querySelector("input")

    if (passwordinput.type === "password") {
      this.buttonTarget.querySelector(".password-show").classList.add("hidden")
      this.buttonTarget
        .querySelector(".password-hide")
        .classList.remove("hidden")
      passwordinput.type = "text"
    } else {
      passwordinput.type = "password"
      this.buttonTarget
        .querySelector(".password-show")
        .classList.remove("hidden")
      this.buttonTarget.querySelector(".password-hide").classList.add("hidden")
    }
  }
}
